import { render } from "./eye_prescriptions.vue?vue&type=template&id=f83661ae&scoped=true"
import script from "./eye_prescriptions.vue?vue&type=script&lang=js"
export * from "./eye_prescriptions.vue?vue&type=script&lang=js"

import "./eye_prescriptions.vue?vue&type=style&index=0&id=f83661ae&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f83661ae"]])

export default __exports__